import React from 'react';
import PropTypes from 'prop-types';

import Badge from "UI/Badge";
import Button from "UI/Button";
import TextField from "UI/Form/TextField";
import TextArea from "UI/Form/TextArea";

import validate from "Data/projects/ProjectValidators";
import Form from "Components/Form";
import Modal from "UI/Modal";
import ModalConfirm from "../../ui/ModalConfirm";

export default class ProjectSettingsDialog extends React.Component
{
    state = {
        busy: false,
        failed: false,

        showConfirmDeleteModal: false,
    };

    static propTypes = {
        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,

        project: PropTypes.object.isRequired,
        onRemove: PropTypes.func.isRequired,
        onSave: PropTypes.func.isRequired
    };

    onSubmit = data => {
        this.setState({busy: true}, () => {
            this.props.onSave(
                this.props.project.id,
                data.name,
                data.description,
                data.colour
            ).then(() => {
                this.onClose();
            }).catch(error => {
                this.setState({busy: false});
            });
        });
    };

    onClose = e => {
        if (e) {
            e.preventDefault;
        }

        this.setState({busy: false}, this.props.onClose);
    }

    onClickDelete = e => {
        e.preventDefault();
        this.setState({showConfirmDeleteModal: true});
    };

    render()
    {
        const { open, project } = this.props;

        const defaults = {
            name: project.name,
            description: project.description,
            colour: project.colour,
        };

        return <Modal open={open} onClose={this.onClose} className='w-full max-w-md'>
            <Modal.Header>
                Manage Project
            </Modal.Header>
            <Modal.Content>
                <Form id='project-settings' defaults={defaults} validate={validate} onSubmit={this.onSubmit}>
                    {(data, onChange, validation) =>
                        <>
                            <fieldset disabled={this.state.busy} className="grid grid-cols-3 gap-6">
                                <div className="col-span-3 sm:col-span-2 space-y-1">
                                    <TextField
                                        id='project_name'
                                        label='Project name'
                                        value={data.name}
                                        onChange={onChange('name')}
                                        error={validation.hasErrors('name')}
                                        help={validation.getErrors('name')}
                                    />
                                </div>

                                <div className="col-span-3 sm:col-span-3 space-y-1">
                                    <TextArea
                                        id="about"
                                        label='About'
                                        placeholder='Describe your project.'
                                        value={data.description}
                                        onChange={onChange('description')}
                                        error={validation.hasErrors('description')}
                                        help={validation.getErrors('description')}
                                    />
                                </div>

                                <div className="col-span-3 sm:col-span-3 space-y-1">
                                    <Label htmlFor='colour'>Colour</Label>
                                    <div className="grid grid-cols-2 gap-6 mt-4">
                                        <div className="col-span-1 sm:col-span-1">
                                            <ColourOption
                                                current={data.colour}
                                                colour='gray'
                                                onChange={onChange('colour')}
                                            />
                                            <ColourOption
                                                current={data.colour}
                                                colour='red'
                                                onChange={onChange('colour')}
                                            />
                                            <ColourOption
                                                current={data.colour}
                                                colour='yellow'
                                                onChange={onChange('colour')}
                                            />
                                            <ColourOption
                                                current={data.colour}
                                                colour='green'
                                                onChange={onChange('colour')}
                                            />
                                        </div>
                                        <div className="col-span-1 sm:col-span-1">
                                            <ColourOption
                                                current={data.colour}
                                                colour='blue'
                                                onChange={onChange('colour')}
                                            />
                                            <ColourOption
                                                current={data.colour}
                                                colour='indigo'
                                                onChange={onChange('colour')}
                                            />
                                            <ColourOption
                                                current={data.colour}
                                                colour='purple'
                                                onChange={onChange('colour')}
                                            />
                                            <ColourOption
                                                current={data.colour}
                                                colour='pink'
                                                onChange={onChange('colour')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset disabled={this.state.busy} className="grid grid-cols-3 gap-6 mt-6">
                                <div className="col-span-3 sm:col-span-3 space-y-1">
                                    <Label>Danger Zone</Label>
                                    <Button type='danger' onClick={this.onClickDelete}>Delete Project</Button>
                                </div>
                            </fieldset>

                            <ModalConfirm
                                danger
                                open={this.state.showConfirmDeleteModal}
                                onConfirm={() => this.props.onRemove(this.props.project.id)}
                                onClose={() => this.setState({showConfirmDeleteModal: false})}
                            >
                                Are you sure you wish to remove this Project?
                            </ModalConfirm>

                        </>
                    }
                </Form>
            </Modal.Content>
            <Modal.Footer>
                <Button form='project-settings' type="primary" busy={this.state.busy}>Save</Button>
                <Button onClick={this.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    }
}

const Label = ({htmlFor, children}) => <label htmlFor={htmlFor} className="block text-sm font-medium leading-5 text-gray-700">{children}</label>;

const ColourOption = ({colour, current, onChange}) => <div className="mt-4 flex items-center">
    <input id={`colour_${colour}`} value={colour} defaultChecked={colour === current} onChange={onChange} name='colour' type="radio" className="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out" />
    <label htmlFor={`colour_${colour}`} className="ml-3">
        <Badge colour={colour} className='border capitalize'>{colour}</Badge>
    </label>
</div>;